import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles(() => ({
  modal: {},

  textarea: {
    width: '100%',
    minHeight: '60px',
    borderRadius: '4px',
    resize: 'none',
    border: '1px solid #ced4da',
    padding: '10px 12px',
    fontSize: 15,
    lineHeight: '19px',
    fontWeight: 400,
    color: '#596375',
    transition: '0.3s',

    '&:focus': {
      borderColor: '#a7a7a7',
    },
  },
}));

export default styles;
